import { useMutation } from '@tanstack/react-query';
import api from 'services/api';

const useDownloadReportPdf = () => {
  const download = async ({ experimentId }) => {

    const res = await api.get(`api/v1/trials/experiments/${experimentId}/report/download/report`);

    let filename = `experiment_report_${experimentId}.pdf`;
    const header = res.headers.get('Content-Disposition');
    if (header) {
      const parts = header.split(';');
      filename = parts[1]?.split('=')[1]?.replace(/"/g, '') || filename;
    }

    const data = await res.blob();
    return { data, filename };
  };

  return useMutation(download);
};

export default useDownloadReportPdf;
